import { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { bindActionCreators } from 'redux'

import {
  Flex,
  TabPanel,
  TabPanels,
  Tabs
} from "@chakra-ui/react";
import LaunchdeckButton from '../../../global/components/helper-components/components/LaunchdeckButton';
import { updateDsr } from '../../actions/dsr-actions';
import LaunchdeckModal from '../../../global/components/helper-components/components/LaunchdeckModal';
import LaunchdeckFormInput from '../../../forms/TextInputField/components/LaunchdeckFormInput';

// Note: This is for MAP, Updates, Shared Docs which doesn't store pages in DSR but with their own tables

function SpecialPageSettingsModal({
  dsrId,
  pageType,
  altPageNames,
  handleClosePageSettingsModal,
  // Redux
  dsrPropertiesRedux,
  // Actions
  updateDsr
}) {

  const [displayedPageName, setDisplayedPageName] = useState('');
  const [latestDsrProperties, setLatestDsrProperties] = useState('');
  const [error, setError] = useState('');

  const nameCharacterLimit = 50;

  useEffect(() => {
    if (dsrPropertiesRedux) {
      setLatestDsrProperties(dsrPropertiesRedux)
      const { map: mapAltPageName, sharedDocs: sharedDocsAltPageName, faq: faqAltPageName } = altPageNames || {};

      if (pageType === "map") {
        setDisplayedPageName(mapAltPageName || "Mutual Action Plan")
      } else if (pageType === "sharedDocs") {
        setDisplayedPageName(sharedDocsAltPageName || "Shared Documents")
      } else if (pageType === "faq") {
        setDisplayedPageName(faqAltPageName || "Q&A")
      } 
    }
  }, [dsrPropertiesRedux]);

  const handleSaveDsrProperties = () => {
    if (dsrId && latestDsrProperties) {
      const { altPageNames: currentAltPageNamesProperty } = latestDsrProperties || {}
      const updatedDsrProperties = {
        ...latestDsrProperties,
        altPageNames: {
          ...currentAltPageNamesProperty,
          ...(pageType === "map" ? { map: displayedPageName } 
            : pageType === "sharedDocs" ? { sharedDocs: displayedPageName } 
            : pageType === "faq" && { faq: displayedPageName } ),
        }
      }

      if (updatedDsrProperties) {
        updateDsr({
          dsrId: dsrId,
          dsrProperties: updatedDsrProperties,
          sourceEvent: "save-room-properties"
        })
      }
    }
  }


  const handleClickClosePageSettingsModal = () => {
    setError('')
    setDisplayedPageName("")
    handleClosePageSettingsModal()
  }

  const onChangeHandler = (event) => {
    setError('')

    setDisplayedPageName(event.target.value)
  };

  const handleSavePageSettings = () => {
    if (displayedPageName.length <= 0) {
      setError('pageName')
      return;
    }

    if (!error) {
      handleSaveDsrProperties()
      handleClickClosePageSettingsModal()
    }
  }

  return (
    <LaunchdeckModal
      title='Page settings'
      handleCloseModal={handleClickClosePageSettingsModal}
      showModal={true}
      maxW='35em'
    >

      <Flex direction='column' justify='space-around' alignItems='center' w='100%'>
    
          <Tabs width='100%'>
            <TabPanels padding='24px'>
              <TabPanel>
                <LaunchdeckFormInput
                  label='Page name'
                  name={'pageName'}
                  onChange={onChangeHandler}
                  value={displayedPageName}
                  placeholder="Enter page name"
                  isRequired={true}

                  charLimit={nameCharacterLimit}

                  errorLogic={error === 'pageName'}
                  errorMessage={'Give your page a name'}
                />

                <Flex align='center' justify='flex-end' mt='2em' w='100%'>
                  <LaunchdeckButton bg='brand.500' color='white' onClick={handleSavePageSettings} px='0.5em' label='OK' />
                </Flex>
              </TabPanel>
            </TabPanels>
          </Tabs>
      </Flex>

    </LaunchdeckModal>
  )
}


const mapStateToProps = (state) => {
  return {
    dsrPropertiesRedux: state.draftDsrProperties.properties
  }
}


const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateDsr
    },
    dispatch,
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SpecialPageSettingsModal))
